import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import {
  BidIncrementButton,
  BidIncrementButtonsContainer,
  BidIncrementsContainer,
  ButtonGrid,
  HotKeyLabel,
  Tab,
  TabList,
  TabPanel,
  Tabs,
} from './Styles2';

const BidIncrementContainer2 = () => {
  const {
    AuctionStore: {
      auctionLaneId,
      connected,
      getLaneSettingArrayByProp,
      getLaneSettingByProp,
      laneSettings,
    },
    BidStore: {
      auction,
      lanePaused,
      laneSuspended,
    },
    UIStore: {
      getHotKey,
      handleBidIncrementClick,
      handleBidIncrementTabClick,
    },
  } = useStores();

  const getButtonColor = (value) => {
    if (auction.selectedBidIncrementTabIndex === 0) {
      return getLaneSettingByProp('DefaultBidIncrement') === value ? 'black' : 'white';
    }
    return auction.standardBidIncrement === value ? 'black' : 'white';
  };

  const bidIncrementList = getLaneSettingArrayByProp('BidIncrement');

  const strSettings = JSON.stringify(laneSettings);
  useEffect(() => () => null, [strSettings]);

  return (
    <BidIncrementsContainer>
      <Tabs selectedIndex={auction.selectedBidIncrementTabIndex} onSelect={(tabIndex) => handleBidIncrementTabClick(tabIndex)}>
        <TabList>
          <Tab>
            Default ($
            {getLaneSettingByProp('DefaultBidIncrement')}
            )
          </Tab>
          <Tab>Current</Tab>
        </TabList>
        <TabPanel />
        <TabPanel />
      </Tabs>
      <BidIncrementButtonsContainer show id="current-bid-increment">
        <ButtonGrid>
          {bidIncrementList?.map((value) => (
            <BidIncrementButton
              data-testid={`bid-inc-${value}`}
              selected={auction.selectedBidIncrementTabIndex === 0 ? getLaneSettingByProp('DefaultBidIncrement') === Number(value) : auction.standardBidIncrement === Number(value)}
              disabled={
                  auction.selectedBidIncrementTabIndex === 0 ? getLaneSettingByProp('DefaultBidIncrement') === Number(value) : auction.standardBidIncrement === Number(value)
                      || !connected
                      || lanePaused
                      || laneSuspended
                    }
              connected={
                      connected && auctionLaneId && !lanePaused && !laneSuspended
                    }
              key={value}
              onClick={() => {
                handleBidIncrementClick(value);
                handleBidIncrementTabClick(1);
              }}
            >
              $
              {new Intl.NumberFormat().format(value)}
              <HotKeyLabel
                color={getButtonColor(value)}
              >
                {getHotKey('target', value)
                    && getHotKey('target', value).label}
              </HotKeyLabel>
            </BidIncrementButton>
          ))}
          {Array.from({ length: 12 - bidIncrementList?.length }, (_, index) => (
              <BidIncrementButton key={`placeholder-${index}`} disabled>
                -
              </BidIncrementButton>
          ))}
        </ButtonGrid>
      </BidIncrementButtonsContainer>
    </BidIncrementsContainer>
  );
};

export default observer(BidIncrementContainer2);
